// extracted by mini-css-extract-plugin
module.exports = {"centerImg":"CenterImg-module--center-img--1WaM7"};